import Vue from 'vue'
import store from '@/components/Alert/store.js'
const plugin = {
  install(Vue, options) {
    const alert = {
      get(params) {
        return store.dispatch('setAlert', params)
      },
      success(text, timeout = 3000) {
        return this.get({ text, timeout })
      },
      error(text, timeout = 3000) {
        return this.get({ text, timeout, color: 'error' })
      },
      warn(text, timeout = 3000) {
        return this.get({ text, timeout, color: 'warn' })
      },
      color(text, color = 'primary', timeout = 3000) {
        return this.get({ text, timeout, color })
      }
    }
    Vue.prototype.$alert = alert
  }
}
Vue.use(plugin)

export default plugin
